import { format } from 'date-fns';
import koLocale from 'date-fns/locale/ko';

export const localeFormat = (date, dateFormat) =>
  format(date, dateFormat, { locale: koLocale });
